'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _helpers = require('@adparlor-devops/js-anvil/helpers');

var _Builder = require('../components/Builder');

var _Builder2 = _interopRequireDefault(_Builder);

var _selectors = require('../../../../store/selectors');

var _ruleDetails = require('../modules/ruleDetails');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return {
    ruleBranches: (0, _selectors.getRuleBranches)(state),
    entityHierarchy: state.ruleDetails.entityHierarchy,
    currentAdvertiser: (0, _selectors.getCurrentAdvertiserObject)(state),
    meta: (0, _selectors.getMeta)(state),
    ruleSettings: state.ruleDetails.ruleSettings,
    entityScopes: state.ruleDetails.entityScopes,
    editing: state.ruleDetails.editing,
    savable: (0, _selectors.isRuleSavable)(state),
    users: state.ruleDetails.users,
    isPackage: (0, _selectors.getIsPackage)(state),
    ruleset: state.ruleDetails.ruleset,
    scopeEntityType: (0, _selectors.getScopeEntityType)(state.ruleDetails),
    selectedEntityIds: (0, _selectors.getSelectedEntityIds)(state.ruleDetails),
    ruleSaving: state.ruleDetails.saving,
    ruleSettingsValid: state.ruleDetails.ruleSettingsValid,
    isRuleSettingsValid: (0, _selectors.isRuleSettingsValid)(state.ruleDetails.ruleSettings),
    invalidEntities: state.ruleDetails.invalidEntities
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    ruleSettingsActions: (0, _helpers.buildActionsCollection)({
      updateRuleSettings: _ruleDetails.updateRuleSettings,
      updateEntityScope: _ruleDetails.updateEntityScope,
      fetchAdvertiserEntities: _ruleDetails.fetchAdvertiserEntities
    }, dispatch),
    ruleDetailsActions: (0, _helpers.buildActionsCollection)({
      addRuleBranch: _ruleDetails.addRuleBranch,
      removeRuleBranch: _ruleDetails.removeRuleBranch,
      updateRuleBranch: _ruleDetails.updateRuleBranch,
      addConditionGroup: _ruleDetails.addConditionGroup,
      removeConditionGroup: _ruleDetails.removeConditionGroup,
      updateConditionGroup: _ruleDetails.updateConditionGroup,
      addCondition: _ruleDetails.addCondition,
      updateCondition: _ruleDetails.updateCondition,
      removeCondition: _ruleDetails.removeCondition,
      addTask: _ruleDetails.addTask,
      updateTask: _ruleDetails.updateTask,
      removeTask: _ruleDetails.removeTask,
      editEntity: _ruleDetails.editEntity,
      fetchTriggersAndOperators: _ruleDetails.fetchTriggersAndOperators,
      fetchLocations: _ruleDetails.fetchLocations
    }, dispatch),
    builderActions: (0, _helpers.buildActionsCollection)({
      saveRule: _ruleDetails.saveRule,
      updateEntitiesValidation: _ruleDetails.updateEntitiesValidation
    }, dispatch)
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_Builder2.default);


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/majesty/lib/components/core/Builder/containers/BuilderContainer.js
// module id = 3767
// module chunks = 4